module.exports = __webpack_public_path__ + "img/footera_508.602cd640.jpg";